"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const CodeInfo = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M14,8 L14,3 L19,8 L14,8 Z M15.414,2 L6,2 C4.897,2 4,2.898 4,4 L4,20 C4,21.103 4.897,22 6,22 L18,22 C19.103,22 20,21.103 20,20 L20,6.586 L15.414,2 Z",
  id: "Fill-1121",
  fill: "#1973E8",
  className: "fill"
}));

var _default = CodeInfo;
exports.default = _default;